import React, { useState } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";
import myImage from "../assets/my-image.webp";

const Hero = () => {
  const [loaded, setLoaded] = useState(false);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      id="home"
      sx={{
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        pb: { xs: 8, md: 0 },
        backgroundColor: "#fff",
        color: "#000",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1100px",
          width: "100%",
          gap: 5,
        }}
      >

        {/* TEXT */}
        <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* FIXED */}
            <Typography
              sx={{
                letterSpacing: 2,
                color: "#333", // ✅ FIX contrast
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              WELCOME TO MY PORTFOLIO
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 32, md: 44 },
                fontWeight: 700,
                mt: 2,
                color: "#000",
              }}
            >
              Hi, I'm Ali 👋
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 18, md: 22 },
                mt: 2,
                color: "#222", // ✅ stronger contrast
                fontWeight: 500,
              }}
            >
              Full Stack Developer & Accounting Specialist
            </Typography>

            <Typography
              sx={{
                mt: 2,
                color: "#444", // ✅ FIX (instead of #555)
                lineHeight: 1.8,
              }}
            >
              I build ERP systems, accounting platforms, VAT systems, payroll,
              financial control systems and business automation tools.
            </Typography>
          </motion.div>

          <Stack
            direction="row"
            spacing={2}
            justifyContent={{ xs: "center", md: "flex-start" }}
            sx={{ mt: 4 }}
          >
            <Button
              variant="contained"
              onClick={() => scrollToSection("projects")}
              sx={{
                backgroundColor: "#000",
                color: "#fff",
                "&:hover": { backgroundColor: "#333" },
              }}
            >
              View Projects
            </Button>

            <Button
              variant="outlined"
              onClick={() => scrollToSection("contact")}
              sx={{
                borderColor: "#000",
                color: "#000",
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              Contact Me
            </Button>
          </Stack>

        </Box>

        {/* IMAGE */}
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              width: 280,
              height: 280,
              borderRadius: "50%",
              padding: "6px",
              background: loaded
                ? "linear-gradient(135deg, #000, #555)"
                : "#e0e0e0",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              transition: "0.4s",
            }}
          >
            <Box
              component="img"
              src={myImage}
              alt="Ali Gharib Full Stack Developer Portfolio"
              loading="lazy"
              decoding="async"
              fetchPriority="high"
              onLoad={() => setLoaded(true)}
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                opacity: loaded ? 1 : 0,
                transition: "0.5s ease-in",
              }}
            />
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default Hero;